import React from 'react'
import DoubleLeafIcon from '../icons/DoublwQuotes'

interface TestimonialCardProps {
  description: string
  name: string
  designation: string
  organization: string
  file?: string
  link?: string
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  description,
  name,
  designation,
  organization,
  file,
  link,
}) => {
  // helper function to check file type
  const isVideo = file?.match(/\.(mp4|webm|ogg)$/i)
  const getEmbedUrl = (url: string) => {
    if (!url) return ''

    // YouTube full URL: https://www.youtube.com/watch?v=VIDEO_ID
    if (url.includes('youtube.com')) {
      const videoId = new URL(url).searchParams.get('v')
      return videoId ? `https://www.youtube.com/embed/${videoId}` : url
    }

    // YouTube short URL: https://youtu.be/VIDEO_ID
    if (url.includes('youtu.be')) {
      const videoId = url.split('/').pop()?.split('?')[0]
      return videoId ? `https://www.youtube.com/embed/${videoId}` : url
    }

    // Otherwise return original URL (could be Vimeo or other)
    return url
  }

  // const renderMedia = () => {
  //   if (link) {
  //     return (
  //       <iframe
  //         src={getEmbedUrl(link)}
  //         title="Testimonial Video"
  //         className="w-full h-64 rounded-lg"
  //         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  //         allowFullScreen
  //       ></iframe>
  //     )
  //   }

  //   if (isVideo) {
  //     return (
  //       <video
  //         src={file}
  //         controls
  //         className="w-full h-64 rounded-lg object-cover"
  //       />
  //     )
  //   }
  //   if (file) {
  //     return (
  //       <img
  //         src={file}
  //         alt={name}
  //         className="w-16 h-16 rounded-full object-cover"
  //       />
  //     )
  //   }
  //   return null
  // }
  const renderMedia = () => {
    if (link) {
      return (
        <div className="relative w-full h-64 rounded-lg">
          <iframe
            src={getEmbedUrl(link)}
            title="Testimonial Video"
            className="w-full h-full rounded-lg pointer-events-none"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          <div
            className="absolute top-0 left-0 w-full h-full cursor-pointer"
            onDoubleClick={() =>
              link && window.open(link, '_blank', 'noopener,noreferrer')
            }
          ></div>
        </div>
      )
    }

    if (isVideo) {
      return (
        <div className="relative w-full h-64 rounded-lg">
          <video
            src={file}
            controls
            className="w-full h-full rounded-lg object-cover"
          />
          <div
            className="absolute top-0 left-0 w-full h-full cursor-pointer"
            onDoubleClick={() =>
              file && window.open(file, '_blank', 'noopener,noreferrer')
            }
          ></div>
        </div>
      )
    }

    if (file) {
      return (
        <div
          onDoubleClick={() =>
            file && window.open(file, '_blank', 'noopener,noreferrer')
          }
          className="cursor-pointer"
        >
          <img
            src={file}
            alt={name}
            className="w-16 h-16 rounded-full object-cover"
          />
        </div>
      )
    }

    return null
  }
  return (
    <div className="bg-white shadow-md rounded-lg lg:px-16 py-10 p-5 max-w-4xl w-full">
      <DoubleLeafIcon className="mb-8" />

      {/* if video/url show side by side layout */}
      {link || isVideo ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 justify-between">
          {/* Left side description */}
          <div>
            <p
              className="text-black text-md text-Barlow leading-relaxed mb-2 line-clamp-6"
              title={description}
            >
              {description
                ? description.charAt(0).toUpperCase() + description.slice(1)
                : ''}
            </p>

            <p className="text-sm font-semibold">
              {name ? name.charAt(0).toUpperCase() + name.slice(1) : ''}
            </p>
            <p className="text-xs text-gray-500">
              {designation
                ? designation.charAt(0).toUpperCase() + designation.slice(1)
                : ''}
            </p>
            <p className="text-xs text-gray-500">{organization}</p>
          </div>

          {/* Right side video/iframe */}
          <div>{renderMedia()}</div>
        </div>
      ) : (
        <>
          {/* Default design for image testimonials */}
          <p
            className="text-black text-md text-Barlow leading-relaxed mb-2 line-clamp-6"
            title={description}
          >
            {description
              ? description.charAt(0).toUpperCase() + description.slice(1)
              : ''}
          </p>
          <div className="flex items-center gap-4">
            {renderMedia()}
            <div>
              <p className="text-sm font-semibold">
                {name ? name.charAt(0).toUpperCase() + name.slice(1) : ''}
              </p>
              <p className="text-xs text-gray-500">
                {designation
                  ? designation.charAt(0).toUpperCase() + designation.slice(1)
                  : ''}
              </p>

              <p className="text-xs text-gray-500">{organization}</p>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default TestimonialCard
